import { Component, Fragment, h, Prop, State, Watch } from '@stencil/core';
import { BookingDetails, StepItem, StepOffers } from '../../../redux/types';
import { Unsubscribe } from '@stencil/redux';
import { store } from '../../../redux/store';
import { markStepAsLoaded } from '../../../redux/actions';
import { ShortArticle } from '../../../types/types';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rentware-items-list',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareItemsList {
  @Prop({ mutable: true }) stepOffers: StepOffers;
  @Prop() currentStep: StepItem;
  @Prop() bookingDetails: BookingDetails;

  @State() activeTabId: string;
  @State() amountToBook: number = 1;
  @State() areTabsLoaded: boolean = false;
  @State() areArticlesLoaded: boolean = false;

  unsubscribe!: Unsubscribe;
  markStepAsLoaded!: typeof markStepAsLoaded;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, state => {
      return {
        stepOffers: state.stepOffers,
      };
    });

    store.mapDispatchToProps(this, {
      markStepAsLoaded,
    });
  }

  componentDidLoad() {
    this.markStepAsLoaded(this.currentStep.id);
  }

  componentDidUpdate() {
    // todo: handle it better way than this hacky way (could cause infinite loop - protected inside action)
    this.markStepAsLoaded(this.currentStep.id);
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  @Watch('stepOffers')
  handleOffersChanged(newOffers: StepOffers, oldOffers: StepOffers) {
    const newTabs = newOffers?.tabs;
    const oldTabs = oldOffers?.tabs;

    if (newTabs?.[0]?.id && newTabs[0]?.id !== oldTabs?.[0]?.id) {
      this.activeTabId = newTabs[0].id;
    }
  }

  handleTabsLoaded = () => {
    if (this.tabs.length > 0) {
      this.activeTabId = this.tabs[0].id;
    }

    this.areTabsLoaded = true;
  };

  handleArticleLoaded = () => {
    this.areArticlesLoaded = true;
  };

  handleClickOnTab = (newTabId: string) => {
    this.activeTabId = newTabId;
  };

  get tabs() {
    return this.stepOffers?.tabs?.filter(tab => tab.items.length > 0) ?? [];
  }

  get articles() {
    return (this.tabs.find(tab => tab.id === this.activeTabId)?.items && this.tabs.find(tab => tab.id === this.activeTabId).items) || [];
  }

  get translatedTabs() {
    return this.tabs.map(item => {
      return {
        ...item,
        name: t('steps.stepTabName:' + item.id),
      };
    });
  }

  get skeletonTabs() {
    return this.tabs.map(() => {
      return {};
    });
  }

  get componentLoaded(): boolean {
    // return this.areTabsLoaded && this.areArticlesLoaded;
    // temp fix - check only if tabs are loaded as articles are buggy
    return this.areTabsLoaded && this.stepOffers && !this.stepOffers.isLoading;
  }

  get componentStyle() {
    return !this.componentLoaded
      ? {
          display: 'none',
        }
      : {};
  }

  get stepKey(): string {
    return this.currentStep.id;
  }

  get listArticles(): ShortArticle[] {
    return this.articles.map(item => {
      const available = item.quantity > 0 && item.netPrice !== null && item.netPrice !== undefined;

      return {
        id: item.id,
        orderItemId: item.orderItemId,
        name: item.name,
        title: item.title,
        description: item.description,
        image: item.image,
        images: [item.image],

        available: available,
        quantityInCart: item.quantityInCart,
        minQuantity: item.minQuantity,
        maxQuantity: item.maxQuantity,
        price: {
          net: item.netPrice,
          gross: item.grossPrice,
          priceCalculation: item.priceCalculationType,
        },

        mileageOptions: item.mileageOptions,
        mileageIdInCart: item.mileageIdInCart,
        variation: item.variation,
      };
    });
  }

  render() {
    return (
      <Fragment>
        {!this.componentLoaded && <rentware-list-articles-template-skeleton tabs={this.skeletonTabs} />}

        <rentware-list-articles-template
          style={this.componentStyle} //controls if component can be displayed
          componentLoaded={this.componentLoaded}
          articles={this.listArticles}
          tabs={this.translatedTabs}
          bookingDetails={this.bookingDetails}
          activeTabId={this.activeTabId}
          stepKey={this.stepKey}
          onTabClick={this.handleClickOnTab}
          onTabsLoaded={this.handleTabsLoaded}
          onArticlesLoaded={this.handleArticleLoaded}
        />
      </Fragment>
    );
  }
}
